import React from 'react';
import { H2 } from './styleConstants';
import { Container } from '..';
import { CustomImage as Image } from '..';
import styles from './InfoCardsGrid.module.css';
// import { getCompressedAssetUrl } from 'lib/config/assetUrls';

type CardContent = {
  title: string;
  description: string;
  image: string;
  blendMode?: React.CSSProperties['mixBlendMode'];
};

const cardItems: CardContent[] = [
  {
    title: 'Sleep Health',
    description:
      'Track sleep duration, quality, and fragmentation to understand recovery, cognitive readiness, and long-term sleep trends across individuals, teams, or patient populations.',
    image: 'web_v2/partners/partners-benefits/Sleep.png',
  },
  // {
  //   title: 'Activity & Performance',
  //   description:
  //     'Monitor movement, training load, and physiological adaptation to optimise performance, guide training decisions, and reduce the risk of injury or overtraining.',
  //   image: 'web_v2/partners/partners-benefits/Activity-v2.png',
  // },
  {
    title: 'Performance, Stress & Recovery',
    description:
      'Monitor movement, training load, and physiological signals like HRV, heart rate, and sleep to manage stress, guide training decisions, optimise performance, and reduce injury or burnout risk over time.',
    image: 'web_v2/partners/partners-benefits/activity-performance.png',
  },
  {
    title: 'Respiratory Health',
    description:
      'Identify snoring, coughing, and breathing disruptions during sleep, and understand how respiratory events impact heart rate, HRV, sleep quality, and recovery across nights.',
    image: 'web_v2/partners/partners-benefits/Respiratory.png',
  },
  {
    title: 'Cardiovascular Health',
    description:
      'Analyse nightly heart rhythms to assess cardio adaptability and recovery capacity, while detecting irregular heart patterns, including signals associated with atrial fibrillation.',
    image: 'web_v2/partners/partners-benefits/Cardiovascular.png',
  },
  {
    title: 'Metabolic Health',
    description:
      'Understand metabolic responses through continuous glucose and related biomarkers to inform nutrition, activity timing, and lifestyle decisions at an individual or population level.',
    image: 'web_v2/partners/partners-benefits/Metabolic-v2.png',
  },
  {
    title: "Women's Health",
    description:
      'Support women across the full reproductive journey, from cycle tracking and ovulation confirmation to conception and pregnancy, using cycle flags to surface unique patterns.',
    image: 'web_v2/partners/partners-benefits/Womens-health.png',
  },
];

export const InfoCardsGrid = ({ className }: { className?: string }) => {
  return (
    <section
      className={`${styles.root}${className ? ` ${className}` : ''}`}
    >
      <Container className={styles.container}>
        <div className={styles.textContent}>
          <H2 className={styles.h2White} style={{ marginBottom: '12px' }}>
            The complete health stack, without precedent
          </H2>
          {/* <Subtitle style={{ margin: '0 auto' }}>
            Ultrahuman Home and Ring AIR work together through UltraSync,
            correlating how your environment and physiology impact your sleep
            and recovery.
          </Subtitle> */}
        </div>

        <div className={styles.grid} role="list" aria-label="Ring with Home features">
          {cardItems.map((item, index) => (
            <article
              className={styles.darkCard}
              key={`${item.title}-${index}`}
              role="listitem"
            >
              <div className={styles.cardAsset}>
                <Image
                  className={styles.cardImage}
                  src={item.image}
                  alt={item.title}
                  style={
                    {
                      '--blend-mode': item.blendMode ?? 'normal',
                    } as React.CSSProperties
                  }
                  width={800}
                  height={600}
                />
              </div>
              <div className={styles.cardText}>
                <h3 className={styles.cardTitle}>{item.title}</h3>
                <p
                  className={styles.cardSubtitle}
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
              </div>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
};
